import { render, staticRenderFns } from "./CompVamosPaLaCalleEventDetail.vue?vue&type=template&id=83ba9b30"
import script from "./CompVamosPaLaCalleEventDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CompVamosPaLaCalleEventDetail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports